var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46109 5.99141C0.46109 2.70305 3.11256 0.0333862 6.38887 0.0333862C9.66518 0.0333862 12.3166 2.70305 12.3166 5.99141C12.3166 7.57236 11.3316 9.60668 9.51629 12.0525L9.51371 12.056L9.07745 12.6315C8.54617 13.3176 7.95033 14.0373 7.28951 14.7941L7.28724 14.7967L6.72352 15.4319C6.67712 15.4902 6.61532 15.5366 6.54264 15.5646C6.37754 15.6282 6.19033 15.5836 6.07164 15.4524C5.24763 14.5415 4.457 13.6011 3.7013 12.6328L3.69759 12.628L3.26143 12.0525C1.44612 9.60669 0.46109 7.57236 0.46109 5.99141ZM6.38694 14.5222L6.64506 14.2314L6.6462 14.2301C7.29703 13.4847 7.88105 12.779 8.39963 12.1094L8.83055 11.5409C10.6352 9.10912 11.4611 7.272 11.4611 5.99141C11.4611 3.17111 9.18823 0.888942 6.38887 0.888942C3.58951 0.888942 1.31665 3.17111 1.31665 5.99141C1.31665 7.27199 2.14254 9.10909 3.94714 11.5409L4.37762 12.1088C5.0219 12.9342 5.69201 13.7391 6.38694 14.5222Z",
    fill: "#62778E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38877 4.09746C5.35938 4.09746 4.52489 4.93195 4.52489 5.96135C4.52489 6.99075 5.35938 7.82524 6.38877 7.82524C7.41817 7.82524 8.25266 6.99075 8.25266 5.96135C8.25266 4.93195 7.41817 4.09746 6.38877 4.09746ZM3.66933 5.96135C3.66933 4.45944 4.88687 3.24191 6.38877 3.24191C7.89068 3.24191 9.10822 4.45944 9.10822 5.96135C9.10822 7.46326 7.89068 8.6808 6.38877 8.6808C4.88687 8.6808 3.66933 7.46326 3.66933 5.96135Z",
    fill: "#62778E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.c54a9e3a9480cb08c4e273539a30c718.svg";
export { ForwardRef as ReactComponent };